import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";

export default () => {
  let editor;

  return {
    init() {
      editor = new Editor({
        element: this.$refs.editor,
        extensions: [
          Link.configure({ HTMLAttributes: { rel: null }, openOnClick: false }),
          StarterKit,
        ],
        editorProps: {
          attributes: {
            class: "prose max-w-none p-3 focus:outline-hidden h-80",
          },
        },
        content: this.$refs.input.value,
        onUpdate: ({ editor }) => {
          this.$refs.input.value = editor.getHTML();
        },
        onTransaction: ({ editor, transaction }) => {
          [
            "bold",
            "italic",
            "strike",
            "link",
            "paragraph",
            "bulletList",
            "orderedList",
            "blockquote",
          ].forEach((state) =>
            this.$refs[state].classList.toggle(
              "bg-blue-100",
              editor.isActive(state),
            ),
          );
          this.$refs.headingOne.classList.toggle(
            "bg-blue-100",
            editor.isActive("heading", { level: 1 }),
          );
          this.$refs.headingTwo.classList.toggle(
            "bg-blue-100",
            editor.isActive("heading", { level: 2 }),
          );
        },
      });
    },

    destroy() {
      editor.destroy();
    },

    bold(e) {
      e.preventDefault();
      editor.chain().focus().toggleBold().run();
    },

    italic(e) {
      e.preventDefault();
      editor.chain().focus().toggleItalic().run();
    },

    strike(e) {
      e.preventDefault();
      editor.chain().focus().toggleStrike().run();
    },

    // Copied code from https://tiptap.dev/api/marks/link
    link(e) {
      e.preventDefault();
      const previousUrl = editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);

      // cancelled
      if (url === null) {
        return;
      }

      // empty
      if (url === "") {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();

        return;
      }

      // update link
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: url })
        .run();
    },

    headingOne(e) {
      e.preventDefault();
      editor.chain().focus().toggleHeading({ level: 1 }).run();
    },

    headingTwo(e) {
      e.preventDefault();
      editor.chain().focus().toggleHeading({ level: 2 }).run();
    },

    paragraph(e) {
      e.preventDefault();
      editor.chain().focus().setParagraph().run();
    },

    bulletList(e) {
      e.preventDefault();
      editor.chain().focus().toggleBulletList().run();
    },

    orderedList(e) {
      e.preventDefault();
      editor.chain().focus().toggleOrderedList().run();
    },

    blockquote(e) {
      e.preventDefault();
      editor.chain().focus().toggleBlockquote().run();
    },

    horizontalRule(e) {
      e.preventDefault();
      editor.chain().focus().setHorizontalRule().run();
    },

    hardBreak(e) {
      e.preventDefault();
      editor.chain().focus().setHardBreak().run();
    },

    clearFormat(e) {
      e.preventDefault();
      editor.chain().focus().unsetAllMarks().run();
      editor.chain().focus().clearNodes().run();
    },

    undo(e) {
      e.preventDefault();
      editor.chain().focus().undo().run();
    },

    redo(e) {
      e.preventDefault();
      editor.chain().focus().redo().run();
    },

    focus(e) {
      e.preventDefault();
      editor.commands.focus();
    },
  };
};
